import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { useWorkersService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';
export var useAvatarImage = function useAvatarImage() {
  var _useState = useState(),
      avatarImage = _useState[0],
      setAvatarImage = _useState[1];

  var _useAuth = useAuth(),
      user = _useAuth.user;

  var workerService = useWorkersService();
  useEffect(function () {
    var callFetchWorkerAsset = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (user !== null && user !== void 0 && user.picture) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return workerService.fetchWorkerAsset(user === null || user === void 0 ? void 0 : user.picture);

              case 5:
                response = _context.sent;
                setAvatarImage(response.data);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                console.error("error fetching worker asset", _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }));

      return function callFetchWorkerAsset() {
        return _ref.apply(this, arguments);
      };
    }();

    callFetchWorkerAsset();
  }, [user === null || user === void 0 ? void 0 : user.picture, workerService]);
  return {
    avatarImage: avatarImage,
    avatarName: (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.business_name)
  };
};